<template>
  <div></div>
</template>

<style lang="scss">
@import "../script/v1/main.scss";
</style>

<script>
import ChatFoodWidget from "../script/v1/ChatFoodWidget";
import axios from "axios";

export default {
  data: () => ({
    domain: process.env.VUE_APP_WIDGET_LINK
  }),
  async mounted() {
    const info = await axios.get(
      `${process.env.VUE_APP_API_LINK}/storefront/v2/businesses/${this.$route.params.slug}/widget`
    );

    new ChatFoodWidget(this.$route.params.slug, info.data.custom_domain);
  }
};
</script>
